import Http from '@/api/http.js'

export default {

  index() {
    return Http.get(`/comissions`)
  },

  create(comission){
    return Http.post(`/comissions`, {comission: {...comission}})
  },

  update(comission){
    return Http.put(`/comissions/${comission.id}`, {
      comission: {...comission},
    });
  },

  show(id) {
    return Http.get(`/comissions/${id}`);
  },

  delete(id){
    return Http.delete(`/comissions/${id}`)
  }

}
